export interface BoxStyleCommitResult {
  committed: number;
  deletions: number;
  newStyleIncluded: boolean;
  hasEditTarget: boolean;
  styleName?: string | null;
  lastDeletedName?: string | null;
}

export interface BoxStyleCommitToast {
  key: string;
  // Strings, not numbers: the bold-toast formatter reads value.length; a raw number yields NaN.
  replacements: Record<string, string>;
  status: "success";
}

// Returns one toast per category that committed. A mixed save+delete commit yields both, so a
// deletion isn't swallowed by the edit toast; the toast queue staggers them ~300ms apart.
export function getBoxStyleCommitToasts(result: BoxStyleCommitResult): BoxStyleCommitToast[] {
  const { committed, deletions, newStyleIncluded, hasEditTarget, styleName, lastDeletedName } =
    result;
  const toasts: BoxStyleCommitToast[] = [];

  if (hasEditTarget && committed > 0) {
    if (committed >= 2) {
      toasts.push({
        key: newStyleIncluded ? "{n} box styles saved" : "{n} box styles updated",
        replacements: { n: String(committed) },
        status: "success"
      });
    } else {
      toasts.push({
        key: newStyleIncluded ? "box style created" : "box style changes saved",
        replacements: { "box style name": styleName ?? "" },
        status: "success"
      });
    }
  }

  if (deletions > 0) {
    if (deletions >= 2) {
      toasts.push({
        key: "{n} box styles deleted",
        replacements: { n: String(deletions) },
        status: "success"
      });
    } else {
      toasts.push({
        key: "box style deleted",
        replacements: { "box style name": lastDeletedName ?? "" },
        status: "success"
      });
    }
  }

  return toasts;
}
